<template>
  <div :class="{ active: show }" class="modal">
    <div v-if="show">
      <div>
        <SurveyAdvancedSettings />
      </div>

      <div class="button">
        <button @click.prevent="closeModal()">
          {{ parseTranslation(CLOSE) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import SurveyAdvancedSettings from './OptionRenderer'

import * as translationIndex from './index.translations'

const { default: translations, ...translationKeys } = translationIndex

export default {
  components: {
    SurveyAdvancedSettings,
  },

  data() {
    return {
      translations,
      ...translationKeys,
      show: false,
    }
  },

  computed: {
    ...mapGetters(['isSurveyAdvancedSettingsModalOpen']),

    isOpenModal() {
      return this.isSurveyAdvancedSettingsModalOpen
    },
  },

  watch: {
    isOpenModal() {
      if (this.isOpenModal) {
        this.openModal()
      }
    },
  },

  methods: {
    ...mapActions(['toggleSurveyAdvancedSettingsModal']),

    openModal() {
      this.show = true
    },

    closeModal() {
      this.show = false
      this.toggleSurveyAdvancedSettingsModal(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  @include background-modal-config;

  &.active {
    display: flex;
  }

  > div {
    @include modal-config(600);
    max-width: 600px;
    width: 100%;
    text-align: center;

    div {
      width: 100%;
    }

    .button {
      display: flex;
      justify-content: flex-end;

      button {
        padding: 8px 15px;
        border-radius: 3px;
        letter-spacing: 0.15em;
        text-transform: uppercase;
        font-weight: 600;
        @include tipography(14);
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);

        background: $blue;
        color: $white;
        border: none;

        &:hover {
          background: $blue-2;
          transform: scale(1.01);
        }

        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>
